import logo from "@/assets/logo.png";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-border/50 bg-card/50">
      <div className="container px-4 py-10 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Brand */}
            <div className="space-y-4 text-center md:text-left">
              <div className="flex items-center gap-3 justify-center md:justify-start">
                <img src={logo} alt="KOSH" className="h-14 w-14" />
                <span className="font-display font-bold text-xl">KOSH</span>
              </div>
              <p className="text-sm text-muted-foreground max-w-xs mx-auto md:mx-0">
                The simplest way to track daily sales, expenses, and profit for Indian small businesses.
              </p>
            </div>

            {/* Contact */}
            <div className="space-y-4 text-center md:text-left">
              <p className="font-display font-semibold text-sm uppercase tracking-wider text-muted-foreground">
                Contact
              </p>
              <div className="space-y-3">
                <a 
                  href="mailto:hello@kosh.click" 
                  className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors justify-center md:justify-start"
                >
                  <Mail className="h-4 w-4" />
                  hello@kosh.click
                </a>
                <div className="flex items-center gap-2 text-sm text-muted-foreground justify-center md:justify-start">
                  <MapPin className="h-4 w-4" />
                  Mumbai, India
                </div>
              </div>
            </div>

            {/* Legal */}
            <div className="space-y-4 text-center md:text-left">
              <p className="font-display font-semibold text-sm uppercase tracking-wider text-muted-foreground">
                Legal
              </p>
              <div className="space-y-3">
                <a href="#" className="block text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </a>
                <a href="#" className="block text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>

        {/* Bottom bar */}
        <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center">
            <p className="text-xs md:text-sm text-muted-foreground">
              © {new Date().getFullYear()} KOSH. All rights reserved.
            </p>
            <p className="text-xs md:text-sm text-muted-foreground">
              Made with ❤️ for Indian Small Businesses
            </p>
          </div>
        </div>

        {/* BWE Studio Attribution */}
        <div className="mt-6 pt-4 border-t border-border/30 text-center">
          <p className="text-xs text-muted-foreground">
            Built by{" "}
            <a 
              href="https://bwestudios.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="font-bold text-primary hover:text-primary/80 transition-colors"
            >
              BWE Studio
            </a>
          </p>
        </div>
      </div>
      </div>
    </footer>
  );
};